import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CopilotContext } from '@Sage/ssm-web5';

import { COPILOT_BAR } from 'constants/Features';
import { getActiveCrudName } from 'utils/crud';

import { getScenarioDetectors } from './scenarios';

/**
 * Shared scenario detection for CopilotBar (wrapper + header trigger).
 */
export default function useCopilotBarScenarioMatch() {
    const location = useLocation();
    const { featureMethods } = useContext(CopilotContext);

    const entityModalState = useSelector((state) => state.entityModal || {});
    const entityCrud = useSelector((state) => state.entityCrud || {});
    const activeCrudName = useSelector((state) => getActiveCrudName(state));
    const entityCrudIsOpen = useSelector((state) => state.entityCrud?.isOpen || false);
    const isCopilotBarEnabled = useSelector(
        (state) => state.config.flagsmith?.[COPILOT_BAR] || false,
    );

    const appState = useMemo(
        () => ({
            entityCrudState: {
                activeCrudName,
                entityCrud,
                isOpen: entityCrudIsOpen,
            },
            entityModalState,
            featureMethods,
            pathname: location.pathname,
        }),
        [
            activeCrudName,
            entityCrud,
            entityCrudIsOpen,
            entityModalState,
            featureMethods,
            location.pathname,
        ],
    );

    const matchingScenario = useMemo(() => {
        if (!isCopilotBarEnabled) return null;
        return getScenarioDetectors().find((d) => d.condition(appState)) || null;
    }, [appState, isCopilotBarEnabled]);

    return { appState, isCopilotBarEnabled, matchingScenario };
}
